<button kendoButton [type]="type" [disabled]="disabled" class="secondary-button">
  @if (icon && iconPosition === 'left') {
    <kendo-svg-icon [icon]="icon" class="secondary-button__icon"></kendo-svg-icon>
  }
  <ng-content></ng-content>
  @if (icon && iconPosition === 'right') {
    <kendo-svg-icon [icon]="icon" class="secondary-button__icon"></kendo-svg-icon>
  }
</button>
